export default "__VITE_ASSET__ii2tTNEC__"